import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import VueSweetalert2 from "vue-sweetalert2";
import GlobalComponents from "./plugins/global-components"; // Import pluginu
import axiosSetup from "./helpers/axios.interceptor";
import { createPinia } from "pinia";

// Import Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "sweetalert2/dist/sweetalert2.min.css";

// Import Bootstrap JavaScript (dla komponentów, np. dropdowny, modale)
import "bootstrap";
const pinia = createPinia();
axiosSetup();
const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(VueSweetalert2);
app.use(GlobalComponents); // Rejestracja globalnych komponentów
app.mount("#app");
